import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError, thrownResponse } from "axios_config/swpc";
import { IAuroraImages } from "./interface";

export const useGetAurroraForcastNorthImages = () => {
  return useQuery<IAuroraImages[] | undefined, AxiosError>(["get-aurora-forcast-north-images"], async () => {
    const res = await axios.get(`/products/animations/ovation_north_24h.json`);
    if (res.status >= 200 && res.status < 300 && typeof res.data) {
      return res.data;
    } else {
      thrownResponse(res);
    }
  });
};

export const useGetAurroraForcastSouthImages = () => {
  return useQuery<IAuroraImages[] | undefined, AxiosError>(["get-aurora-forcast-south-images"], async () => {
    const res = await axios.get(`/products/animations/ovation_south_24h.json`);
    if (res.status >= 200 && res.status < 300 && typeof res.data) {
      return res.data;
    } else {
      thrownResponse(res);
    }
  });
};
